import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getBook = bookId => httpClient.get(apis.GET_FREE_BOOK + bookId);
export const addToFavoriteList = payload =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });
export const generateFile = ({ courseId, bookId, fileId }) =>
  httpClient.get(`${apis.GET_GENERATE_FILE}/${courseId}/${bookId}/${fileId}`);
